import { ToolbarNavItem } from '@app/shared/components/toolbar-nav/toolbar-nav-item';

export const FOOTER_LINKS: ToolbarNavItem[] = [
    {
        label: 'Datenschutz',
        url: 'https://wein-nachhaltig.de/datenschutzerklaerung-tool',
        external: true,
    },
    {
        label: 'Nutzungsbedingungen',
        url: 'https://wein-nachhaltig.de/nutzungsbedingungen',
        external: true,
    },
    {
        label: 'Impressum',
        url: 'https://wein-nachhaltig.de/impressum',
        external: true,
    },
];
